// extracted by mini-css-extract-plugin
export default {"container":"sG-z","header":"tG-z","details":"uG-z","link":"vG-z"};